import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMessage = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0901 21L14.6901 17.19H18.29C19.78 17.19 20.9901 15.98 20.9901 14.49V5.71001C20.9901 4.22001 19.78 3.01001 18.29 3.01001H5.75006C4.26006 3.01001 3.06005 4.21001 3.05005 5.70001L3.00006 14.48C2.99006 15.98 4.20007 17.2 5.70007 17.2H9.29004",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.10986 7.93005H15.8699",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.10986 11.53H11.9899",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMessage;
